// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"86b77f72","321":"03661832","652":"610863a0","809":"9d8f038e","822":"a47ea289"}[chunkId] + ".chunk.css";
};